"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _HBBaseFormField = _interopRequireWildcard(require("../HBBaseFormField/HBBaseFormField"));
var _HBRadioButtonGroup = _interopRequireDefault(require("../HBRadioButtonGroup/HBRadioButtonGroup"));
var _excluded = ["testIdName"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var HBRadioButtonGroupField = function HBRadioButtonGroupField(props) {
  var _splitFieldProps = (0, _HBBaseFormField.splitFieldProps)(props),
    fieldProps = _splitFieldProps.fieldProps,
    _splitFieldProps$inpu = _splitFieldProps.inputProps,
    testIdName = _splitFieldProps$inpu.testIdName,
    inputProps = (0, _objectWithoutProperties2["default"])(_splitFieldProps$inpu, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_HBBaseFormField["default"], fieldProps, /*#__PURE__*/_react["default"].createElement(_HBRadioButtonGroup["default"], (0, _extends2["default"])({}, inputProps, {
    testIdName: testIdName
  })));
};
var _default = exports["default"] = HBRadioButtonGroupField;
//# sourceMappingURL=HBRadioButtonGroupField.js.map